import {Component, OnDestroy, OnInit, inject, ChangeDetectorRef} from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { MaterielSynthese } from '../../models/materiel'
import { DataSharedService } from '../../services/data-shared.service'
import { SyntheseService } from '../../services/synthese.service'
import dayjs from 'dayjs'
import { MaterielService } from '../../services/materiel.service'
import { Subscription } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
import { downloadPdfFile } from '../../utils/utils'
import { PeriodDto } from '../../models/period-dto'
import { StatutLabelPipe } from '../../pipes/statut-label.pipe'
import { FormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap/tooltip';
import { TitleCasePipe, DatePipe } from '@angular/common';
import { JourSynthesePipe } from '../../pipes/jour-synthese.pipe';

@Component({
    selector: 'lg-synthese',
    templateUrl: './synthese.component.html',
    styleUrls: ['./synthese.component.scss'],
    imports: [FormsModule, NgbTooltip, TitleCasePipe, DatePipe, StatutLabelPipe, JourSynthesePipe]
})
export class SyntheseComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private dataSharedService = inject(DataSharedService);
  private syntheseService = inject(SyntheseService);
  private toastr = inject(ToastrService);
  private statutLabelPipe = inject(StatutLabelPipe);
  private cdr = inject(ChangeDetectorRef);
  materielService = inject(MaterielService);

  materielsSynthese: MaterielSynthese[] = []
  months: string[] = []
  chantierCode: string
  loading = false
  period: PeriodDto
  selectedMonth: string
  subscription = new Subscription()

  ngOnInit(): void {
    this.chantierCode = this.route.snapshot.paramMap.get('chantierCode')

    this.loading = true
    this.syntheseService.getSynthesePeriod(this.chantierCode).subscribe({
      next: (period) => {
        if (period) {
          this.period = period
          let startDayjs = dayjs(period.start)
          const endDayjs = dayjs(period.end)

          while (startDayjs.isBefore(endDayjs)) {
            this.months.push(startDayjs.format('YYYY-MM'))
            startDayjs = startDayjs.add(1, 'month')
          }
          this.months.push(endDayjs.format('YYYY-MM'))
          this.selectedMonth = this.months.at(-1)

          this.getMaterielsSynthese()
        } else {
          // Pas de synthese periode (Pas de matériels sur le chantier)
          this.loading = false
        }
        this.cdr.detectChanges()
      },
      error: (err) => {
        if (err.status === 404) {
          this.period = null
          this.months.push(dayjs().format('YYYY-MM'))
          this.getMaterielsSynthese()
        }
        this.loading = false
        this.cdr.detectChanges()
      },
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  getMaterielsSynthese() {
    this.syntheseService.getMaterielsSynthese(this.chantierCode, this.selectedMonth).subscribe({
      next: (materielsSynthese: MaterielSynthese[]) => {
        materielsSynthese.forEach((materielSynthese) => {
          if(materielSynthese.getStatut() ==='HISTORISE') {
            materielSynthese.nbJoursNonPointe = 0
          }
          // On construit le label du dernier événement
          if (materielSynthese.getStatut() === 'SUR_CHANTIER') {
            materielSynthese.lastEvenementWithDate = this.statutLabelPipe.transform(materielSynthese.getStatut())
          } else if (materielSynthese.evenements && materielSynthese.evenements.length > 0) {
            const lastEvenement = materielSynthese.getLastEvenement()
            const lastEvenementDateFormatted = dayjs(lastEvenement.date).format('DD/MM/YYYY')
            materielSynthese.lastEvenementWithDate = `${lastEvenement.type.nom} le ${lastEvenementDateFormatted}`
          }
        })
        this.materielsSynthese = materielsSynthese.sort(
          (a, b) => new Date(a.getDateReception()).getTime() - new Date(b.getDateReception()).getTime()
        )
        this.loading = false
        this.cdr.detectChanges()
      },
      error: (err) => {
        this.loading = false
        this.cdr.detectChanges()
      },
    })
  }

  downloadPdf(materielSynthese: MaterielSynthese) {
    materielSynthese.downloadingPdf = true
    this.cdr.detectChanges()

    this.materielService.downloadMaterielPdf(this.chantierCode, materielSynthese.id).subscribe({
      next: (response) => {
        downloadPdfFile(response)
        this.toastr.success('PDF téléchargé')
        materielSynthese.downloadingPdf = false
        this.cdr.detectChanges()
      },
      error: () => {
        this.toastr.error('Erreur lors du téléchargement du PDF')
        materielSynthese.downloadingPdf = false
        this.cdr.detectChanges()
      },
    })
  }

  openSuiviDesCoupsUrl() {
    window.open('https://reporting.leon-grosse.fr/sense/app/5115e711-af69-4536-ba9e-ba1651b633b9/sheet/7f95451d-1f80-4ed9-bed9-8b9ea813c625/state/analysis','_blank')
  }
}
